import lodash from "lodash";
function isDraftContent(content) {
  return lodash.isArray(content.blocks) && lodash.isObject(content.entityMap);
}
function isRichContent(content) {
  return lodash.isArray(content.nodes);
}
export {
  isDraftContent,
  isRichContent
};
//# sourceMappingURL=content-types.js.map
